const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;

export const formatFileSize = (bytes: number): string => {
  const kilobytes = Math.ceil(bytes / KB);
  if (kilobytes < 1024) return `${kilobytes}KB`;

  const megabytes = (bytes / MB).toFixed(1);
  if (Number(megabytes) < 1024) return `${megabytes}MB`;

  return `${(bytes / GB).toFixed(2)}GB`;
};
